import { render, staticRenderFns } from "./HomeProgramsCardCopy.vue?vue&type=template&id=b044a3ea&scoped=true&"
import script from "./HomeProgramsCardCopy.vue?vue&type=script&lang=js&"
export * from "./HomeProgramsCardCopy.vue?vue&type=script&lang=js&"
import style0 from "./HomeProgramsCardCopy.vue?vue&type=style&index=0&id=b044a3ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b044a3ea",
  null
  
)

export default component.exports